import FormattedMessage from 'I18n/components/FormattedMessage';
import { H7 } from 'foundations-components/transitional/components/H7';

// @ts-expect-error Could not find a declaration file for module
import CategoryGroupDropdown from './CategoryGroupDropdown';
import { FILTER_TYPES_OTHER, getCategoryGroup, getToolGroup } from '../constants/TopFilterConstants';
import { Box } from 'foundations-components/transitional/components/Box';
import { TFlex } from 'foundations-components/transitional/components/TFlex';
import MobileTopFilterPanel from '../containers/TracksPage/MobileTopFilterPanel';
import { useState } from 'react';
import { useSelector } from 'react-redux';
import { getSearch, getSelectedCategoryFiltersFromRoute, getSelectedToolFiltersFromRoute
// @ts-expect-error Could not find a declaration file for module
} from '../selectors/routeSelectors';
import { useHistory } from 'react-router-dom';
import CatalogDropdownContainer from './CatalogDropdown/CatalogDropdownContainer';
import styled, { mediaQuery, css, academyResultsBar, useMediaQuery } from 'academy-common-lib/utils/Styling';
import { IconButton } from 'foundations-components/transitional/components/IconButton';
import { FilterIcon } from 'foundations-assets/icons/components/FilterIcon';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const ResultsBarContainer = styled.div.withConfig({
  displayName: "ResultsStatusBar__ResultsBarContainer"
})(["", " ", " ", ""], academyResultsBar, props => props.sticky === 1 && mediaQuery('notMobile', css(["position:sticky;top:130px;z-index:3;"])), mediaQuery('mobile', css(["height:auto;min-height:60px;padding:10px;line-height:1.5;"])));
const ResultsStatusBar = ({
  startCard,
  endCard,
  mobileFilterTypes = [],
  mobileResultsActions,
  cardsTotal,
  showSort,
  sticky = false,
  loading
}) => {
  const history = useHistory();
  const filterTypeCategories = FILTER_TYPES_OTHER.CATEGORIES;
  const filterTypeTools = FILTER_TYPES_OTHER.TOOLS;
  const selectedCatFilters = useSelector(state => getSelectedCategoryFiltersFromRoute(state, {
    location: history.location
  }));
  const selectedToolFilters = useSelector(state => getSelectedToolFiltersFromRoute(state, {
    location: history.location
  }));
  const selectedSearchTerm = useSelector(state => getSearch(state, {
    location: history.location
  }));
  const selectedTool = [...selectedToolFilters][0];
  const selectedToolGroup = getToolGroup(selectedTool);
  const selectedCategory = [...selectedCatFilters][0];
  const selectedCategoryGroup = getCategoryGroup(selectedCategory);
  const filterType = selectedTool ? filterTypeTools : filterTypeCategories;
  const selectedCat = selectedTool || selectedCategory;
  const selectedGroup = selectedToolGroup || selectedCategoryGroup;
  const {
    isMobile,
    isTablet
  } = useMediaQuery();
  const [filterPanelOpen, setFilterPanelOpen] = useState(false);
  const getTotals = () => {
    return !cardsTotal ? /*#__PURE__*/_jsx(FormattedMessage, {
      message: "academyErrors.filters.noResultsFound"
    }) : /*#__PURE__*/_jsx(FormattedMessage, {
      message: "learningCenter.myLearning.paginatedResultsCount",
      options: {
        startCard,
        endCard,
        cardsTotal
      }
    });
  };
  const getSelectedGroup = () => {
    if (selectedGroup) {
      const groupMessage = filterType === filterTypeTools ? 'softwaregroup' : `${filterType}group`;
      return /*#__PURE__*/_jsxs(_Fragment, {
        children: [!isMobile && /*#__PURE__*/_jsx("span", {
          children: ":\xA0"
        }), /*#__PURE__*/_jsx(CatalogDropdownContainer, {
          buttonText: /*#__PURE__*/_jsx(FormattedMessage, {
            message: `learningCenter.topFilters.${groupMessage}.${selectedGroup}`
          }),
          inlineLink: true
        }), /*#__PURE__*/_jsx("span", {
          children: "\xA0/\xA0"
        })]
      });
    }
    return '';
  };
  const getSelectedSearchTerm = () => {
    return /*#__PURE__*/_jsxs(_Fragment, {
      children: [!isMobile && /*#__PURE__*/_jsx("span", {
        children: ":\xA0"
      }), /*#__PURE__*/_jsx("span", {
        children: selectedSearchTerm
      })]
    });
  };
  const getSelectedCategoryText = () => {
    return /*#__PURE__*/_jsxs(_Fragment, {
      children: [!isMobile && /*#__PURE__*/_jsx("span", {
        children: ":\xA0"
      }), /*#__PURE__*/_jsx(CatalogDropdownContainer, {
        buttonText: /*#__PURE__*/_jsx(FormattedMessage, {
          message: `learningCenter.topFilters.${filterType}.${selectedCat}`
        }),
        inlineLink: true
      })]
    });
  };
  const renderGroupAndDropdown = () => {
    return /*#__PURE__*/_jsxs(_Fragment, {
      children: [getSelectedGroup(), isMobile ? /*#__PURE__*/_jsx(CatalogDropdownContainer, {
        buttonText: /*#__PURE__*/_jsx(FormattedMessage, {
          message: `learningCenter.topFilters.${filterType}.${selectedCat}`
        }),
        inlineLink: true,
        selectedFilterType: filterType,
        selectedGroup: selectedGroup
      }) : /*#__PURE__*/_jsx(CategoryGroupDropdown, {
        filterType: filterType,
        selectedCategory: selectedCat,
        selectedGroup: selectedGroup
      })]
    });
  };
  const getResultsDetail = () => {
    return /*#__PURE__*/_jsx(_Fragment, {
      children: selectedGroup ? renderGroupAndDropdown() : selectedCat ? getSelectedCategoryText() : selectedSearchTerm ? getSelectedSearchTerm() : ''
    });
  };
  const renderFilterButton = () => {
    return /*#__PURE__*/_jsx(IconButton, {
      "data-test-id": "mobile-filter-panel-button",
      onClick: () => setFilterPanelOpen(true),
      size: "medium",
      use: "transparent",
      children: /*#__PURE__*/_jsx(FilterIcon, {
        color: "icon-core-subtle",
        size: "600"
      })
    });
  };
  const renderMobileResults = () => {
    if (loading) return;
    return /*#__PURE__*/_jsxs(TFlex, {
      align: "center",
      children: [/*#__PURE__*/_jsxs(Box, {
        grow: 2,
        children: [/*#__PURE__*/_jsx(H7, {
          marginBlockEnd: "0",
          children: getTotals()
        }), getResultsDetail(), mobileResultsActions]
      }), mobileFilterTypes && mobileFilterTypes.length > 0 && renderFilterButton()]
    });
  };
  const renderResults = () => {
    if (loading) return;
    return /*#__PURE__*/_jsxs(TFlex, {
      alignItems: "center",
      blockSize: "100%",
      color: "text-primary-default",
      inlineSize: "100%",
      marginBlock: "0",
      marginInline: "auto",
      maxInlineSize: "1376px",
      paddingInlineEnd: isTablet ? '300' : isMobile ? '0' : '600',
      paddingInlineStart: isTablet ? '600' : isMobile ? '300' : '1100',
      children: [/*#__PURE__*/_jsx(H7, {
        marginBlockEnd: "0",
        children: getTotals()
      }), getResultsDetail()]
    });
  };
  return /*#__PURE__*/_jsxs(ResultsBarContainer, {
    sticky: sticky ? 1 : 0,
    children: [isMobile ? renderMobileResults() : renderResults(), isMobile && /*#__PURE__*/_jsx(MobileTopFilterPanel, {
      "data-test-id": "mobile-secondary-filter-panel",
      itemsCount: cardsTotal || 0,
      mobileFilterTypes: mobileFilterTypes,
      onCloseClick: () => setFilterPanelOpen(false),
      open: filterPanelOpen,
      showSort: showSort
    })]
  });
};
export default ResultsStatusBar;